import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { base } from '../../redux/thunk';
//Material
import { Box, ClickAwayListener, Grid, Stack, styled, TextField, Typography } from '@mui/material';
import { LetsGoBtn } from '../../components/Buttons';
import ApiService from '../../helpers/apiHelper';
import '../MainPage/index.css';

import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import EmojiPicker from 'emoji-picker-react';
import { useNavigate, useParams } from 'react-router-dom';
import { Element } from 'react-scroll';
import CommentCard from '../../components/CommentCard';
import PostCard from '../../components/PostCard';
import { Spinner } from '../../components/Spinner';
import ReplyIcon from '@mui/icons-material/Reply';
import { Close } from '@mui/icons-material';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'anchor-center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function PostPage(props) {
  const [error, setError] = useState('');
  const [userData, setUserData] = useState({});
  const [isShowEmoji, setIsShowEmoji] = useState(false);
  // eslint-disable-next-line
  const [totalComments, setTotalComments] = useState(null);
  const params = useParams();
  const navigate = useNavigate();

  const apiCommentUpdate = new ApiService('posts/comment/update-comment');
  const apiPosts = new ApiService('posts/post');
  const apiComments = new ApiService('posts/comment');
  const apiGetComments = new ApiService('posts/comment/get-comments');

  // const apiCommentUpdate = new ApiService('/comment/update-comment');
  // const apiPosts = new ApiService('post');
  // const apiComments = new ApiService('/comment');
  // const apiGetComments = new ApiService('/comment/get-comments');

  const [data, setData] = useState([]);
  const [comments, setComments] = useState([]);
  const [startWith, setStartWith] = useState(0);
  const [loadMore, setLoadMore] = useState(false);
  const [contentMaxCount, setContentMaxCount] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [topComment, setTopComment] = useState('');
  const [isResponse, setIsResponse] = useState(false);
  const [responseId, setResponseId] = useState(null);
  const [responseNickname, setResponseNickName] = useState('');

  const inputRef = useRef(null);
  const originalTopRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);

  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  const getComments = () => {
    apiGetComments
      .getItemById(params.id, { page: 0, size: 10 })
      .then((res) => {
        setContentMaxCount(res.total);
        setComments(res.result);

        apiPosts.getItemById(params.id).then((result) => {
          setTotalComments(result?.result?.numberComments);
          if (data && data?.numberComments) {
            if (data?.numberComments !== result?.result?.numberComments) {
              setData({ ...data, numberComments: result?.result?.numberComments });
            }
          }
        });
      })
      .catch((error) => console.error(error));
  };
  const dataSetter = () => {
    setIsLoading(true);
    apiPosts
      .getItemById(params.id)
      .then((res) => {
        setData(res.result);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error?.message.includes(`Post with postId [${params.id}] not found`)) {
          navigate(`/${props.language}/error`);
        }
        if (error?.message.includes(`Can't get post`)) {
          navigate(`/${props.language}/error`);
        }
        console.error(error.message);
      });
  };
  const commentsSwitcher = () => {
    setData({ ...data, turnOnComments: !data?.turnOnComments });
  };
  const handleLoadMore = () => {
    setLoadMore(true);
    apiGetComments
      .getItemById(params.id, { page: startWith + 1, size: 10 })
      .then((res) => {
        setContentMaxCount(res.total);
        setLoadMore(false);
        setComments([...comments, ...res.result]);
        setStartWith(startWith + 1);
      })
      .catch((error) => console.error(error));
  };
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      dataSetter();
      getComments();
    }
    return () => (mounted = false);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (data.length !== 0 && data?.userDTO?.id !== props.userData.id) {
      setUserData(data.userDTO);
    } else {
      setUserData(props.userData);
    }
    // eslint-disable-next-line
  }, [data]);
  // useEffect(() => {
  //   window.addEventListener('scroll', () => setPageScroll(window.scrollY));
  //   return () => {
  //     window.removeEventListener('scroll', () => setPageScroll(window.scrollY));
  //   };
  // });
  useEffect(() => {
    const inputEl = inputRef.current;
    if (!inputEl) return;
    const rect = inputEl.getBoundingClientRect();
    originalTopRef.current = rect.top + window.scrollY;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const originalTop = originalTopRef.current;

      if (originalTop !== null && scrollY >= originalTop - 81) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', () => {});

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line
  }, [inputRef.current]);

  return (
    <Page
      title={`Пост${data?.id ? ` - ${data?.id}` : ''}`}
      sx={{
        display: 'flex',
        marginTop: '110px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 20px 80px', sm: '0px 20px 80px', md: '0px 100px 100px' }
      }}
    >
      {!isLoading ? (
        <>
          {' '}
          <Element name="topPost" />
          <Stack spacing={0} justifyContent="center" alignItems="center">
            <Grid
              container
              style={{
                maxWidth: '700px',
                paddingTop: '65px'
              }}
              spacing={0}
            >
              {/* <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Typography
                  variant="subtitle"
                  sx={{
                    display: 'inline-flex',
                    cursor: 'pointer',
                    color: 'black',
                    ':hover': { color: '#60A5DF' }
                  }}
                  onClick={() => navigate(-1)}
                >
                  <ReplyIcon sx={{ mr: 1, color: 'black' }} />
                  Повернутись на попередню сторінку
                </Typography>
              </Grid> */}
              {/* <Grid item xs={4}/> */}

              <Grid
                item
                xs={12}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                {data.length !== 0 && (
                  <PostCard
                    noWidth
                    sx={{ marginBottom: '10px !important' }}
                    el={data}
                    dataSetter={dataSetter}
                    commentsSwitcher={commentsSwitcher}
                    totalComments={totalComments}
                  />
                )}
              </Grid>
              {isFixed && <div style={{ height: `165px`, width: '100%' }}></div>}
              {!props.blockedUsers.find((user) => user.id === userData?.id) &&
              data?.turnOnComments ? (
                <Grid
                  ref={inputRef}
                  item
                  xs={12}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',

                    position: isFixed ? 'fixed' : 'relative',
                    top: { xs: isFixed ? '81px' : 0 },
                    right: 0,
                    left: 0,
                    backgroundColor: 'white !important',
                    borderRadius: '8px',
                    zIndex: 103
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: 'FixelText-Medium',
                      p: '24px 0px'
                    }}
                  >
                    Коментарі
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      maxWidth: { xs: '350px', sm: '700px' },
                      minWidth: { xs: '350px', sm: '700px' },

                      position: 'relative'
                    }}
                  >
                    <CssTextField
                      disabled={props.blockedUsers.find((user) => user.id === userData?.id)}
                      variant="outlined"
                      placeholder="Додайте Ваш коментар"
                      fullWidth
                      inputProps={{ style: { textAlign: 'left' } }}
                      InputProps={{
                        endAdornment: (
                          <>
                            {isEdit && (
                              <Close
                                sx={{ mr: 1 }}
                                onClick={() => {
                                  setIsEdit(false);
                                  setTopComment('');
                                  setResponseId(null);
                                }}
                              />
                            )}

                            <EmojiEmotionsOutlinedIcon
                              onClick={() => {
                                setIsShowEmoji(!isShowEmoji);
                              }}
                              sx={{
                                display: { xs: 'none', md: 'inline-block' },
                                color: '#7C7C7C',
                                cursor: 'pointer',
                                fontSize: '20px',
                                mr: 1
                              }}
                            />
                          </>
                        ),
                        startAdornment: isResponse && (
                          <span style={{ marginRight: '8px', color: '#7C7C7C' }}>
                            @{responseNickname}
                          </span>
                        )
                      }}
                      value={topComment}
                      onChange={(event) => {
                        if (isShowEmoji) {
                          setIsShowEmoji(false);
                        }
                        if (event.target.value.length <= 500) setTopComment(event.target.value);
                        setError('');
                      }}
                    />
                    {isShowEmoji && (
                      <ClickAwayListener
                        onClickAway={() => {
                          setIsShowEmoji(false);
                        }}
                      >
                        <Box>
                          <EmojiPicker
                            onEmojiClick={(emojiData, event) => {
                              let newStr = `${topComment}${emojiData.emoji}`;
                              setTopComment(newStr);
                            }}
                            skinTonesDisabled
                            searchDisabled
                            previewConfig={{ showPreview: false }}
                            style={{
                              position: 'absolute',
                              bottom: '-290px',
                              right: '50px',
                              zIndex: '999'
                            }}
                            width={'350px'}
                            height={'300px'}
                          />
                        </Box>
                      </ClickAwayListener>
                    )}
                    <Box
                      sx={{
                        display: 'flex',
                        width: '42px',
                        height: '42px',
                        padding: '4px 9px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '50px',
                        background: ' #60A5DF',
                        ml: '8px',
                        cursor: 'pointer',
                        ':hover': {
                          boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 15px -5px',
                          background: ' #F5F4F4'
                        }
                      }}
                      onClick={debounce(() => {
                        if (topComment.length === 0) {
                          setError('Мінімальна довжина: 1 символ');
                        } else if (topComment.length > 500) {
                          setError('Максимальна довжина: 500 символів');
                        } else {
                          if (!isEdit) {
                            apiComments
                              .sendRequest({
                                text: topComment,
                                id: !isResponse ? params.id : responseId,
                                typeComment: !isResponse ? 'post' : 'response'
                              })
                              .then((res) => {
                                setTopComment('');
                                getComments();
                                setIsResponse(false);
                                setResponseId(null);
                                setResponseNickName(null);
                                setIsEdit(false);
                              });
                          } else {
                            apiCommentUpdate
                              .updateDataID(responseId, { text: topComment })
                              .then((res) => {
                                getComments();
                                setIsResponse(false);
                                setResponseId(null);
                                setResponseNickName(null);
                                setIsEdit(false);
                                setTopComment('');
                              });
                          }
                        }
                      })}
                    >
                      <ReplyIcon
                        sx={{
                          color: 'white',
                          ':hover': {
                            color: '#7c7c7c'
                          }
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'ctart',
                      justifyContent: error.length !== 0 ? 'space-between' : 'end',
                      maxWidth: { xs: '350px', sm: '700px' },
                      minWidth: { xs: '350px', sm: '700px' }
                    }}
                  >
                    {error.length !== 0 && (
                      <p
                        style={{
                          margin: '0 5px',
                          color: 'red',
                          textAlign: 'left',
                          fontSize: '14px'
                        }}
                      >{`${error}`}</p>
                    )}
                    {!props.blockedUsers.find((user) => user.id === userData?.id) &&
                    data?.turnOnComments ? (
                      <p
                        style={{
                          margin: '0 5px',
                          color: 'gray',
                          textAlign: 'left',
                          fontSize: '14px',
                          paddingLeft: '20px'
                        }}
                      >{`${topComment.length}/500`}</p>
                    ) : null}
                  </Box>
                </Grid>
              ) : (
                <Grid item xs={12} />
              )}

              {/*<Grid item xs={4} />*/}

              {/*<ToTopBtn*/}
              {/*  to="topPost"*/}
              {/*  visible={pageScroll > 1500}*/}
              {/*  sx={{ position: 'fixed', right: '-80px', bottom: '0' }}*/}
              {/*  icon={<ArrowUpwardIcon sx={{ fontSize: '22px' }} />}*/}
              {/*/>*/}

              {comments.length !== 0 &&
                comments.map((comment, index) => (
                  <React.Fragment key={`comment${index}`}>
                    <Grid item xs={12} sx={{ mt: '24px' }}>
                      <CommentCard
                        data={comment}
                        isOnComments={data?.turnOnComments}
                        setter={getComments}
                        setIsResponse={setIsResponse}
                        setResponseId={setResponseId}
                        setResponseNickName={setResponseNickName}
                        setTopComment={setTopComment}
                        setIsEdit={setIsEdit}
                      />
                    </Grid>
                  </React.Fragment>
                ))}
              {contentMaxCount > startWith + 1 && (
                <React.Fragment key={`loadMore`}>
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <LetsGoBtn
                      colorScheme="white"
                      sx={{ margin: '30px auto !important' }}
                      text={loadMore ? <Spinner type="small" /> : 'Завантажити ще'}
                      onClick={handleLoadMore}
                    />
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
          </Stack>
        </>
      ) : (
        <div
          style={{
            // height: '240px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginBottom: '100px',
            height: '100vh'
          }}
        >
          <Spinner />
        </div>
      )}
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscribers: state.global.userSubscribers,
    subscriptions: state.global.userSubscriptions,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps, {
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk
})(PostPage);
